import { money, finApi } from "../api";
import { waPhone } from "./shareInvoice";
import { esc, themeCss, nationalAddress, RIYAL, DEFAULT_THEME, printInvoice, invoicePdf } from "./invoicePrint";

const ONES = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة", "أحد عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر", "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"];
const TENS = ["", "", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
const HUND = ["", "مائة", "مائتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"];
const SCALES = [["", "", "", ""], ["ألف", "ألفان", "آلاف", "ألف"], ["مليون", "مليونان", "ملايين", "مليون"], ["مليار", "ملياران", "مليارات", "مليار"]];

const under1000 = (n) => {
  const h = Math.floor(n / 100), r = n % 100, parts = [];
  if (h) parts.push(HUND[h]);
  if (r) parts.push(r < 20 ? ONES[r] : (r % 10 ? `${ONES[r % 10]} و${TENS[Math.floor(r / 10)]}` : TENS[Math.floor(r / 10)]));
  return parts.join(" و");
};

export function tafqeet(num) {
  let n = Math.floor(Math.abs(num));
  if (!n) return "صفر";
  const groups = [];
  for (let i = 0; n > 0; i++, n = Math.floor(n / 1000)) {
    const g = n % 1000;
    if (!g) continue;
    const [one, two, few, many] = SCALES[i];
    let w;
    if (i === 0) w = under1000(g);
    else if (g === 1) w = one;
    else if (g === 2) w = two;
    else if (g >= 3 && g <= 10) w = `${under1000(g)} ${few}`;
    else w = `${under1000(g)} ${many}`;
    groups.unshift(w);
  }
  return groups.join(" و");
}

export const amountWords = (v) => {
  const a = Math.round(Math.abs(Number(v) || 0) * 100);
  const r = Math.floor(a / 100), h = a % 100;
  return `${tafqeet(r)} ريال سعودي${h ? ` و${tafqeet(h)} هللة` : ""} فقط لا غير`;
};

const row = (ar, en, val) => `<tr><td class="lbl">${ar}</td><td>${val}</td><td class="lbl en">${en}</td></tr>`;

export function buildVoucherHtml(p, { seller = {}, logo, theme }) {
  const th = { ...DEFAULT_THEME, ...(theme || {}) };
  const isIn = p.direction === "in";
  const [tAr, tEn] = isIn ? ["سند قبض", "Receipt Voucher"] : ["سند صرف", "Payment Voucher"];
  const sign = isIn ? ["المستلم (المحاسب)", "الدافع", "المدير المالي"] : ["المحاسب", "المستلم", "المدير المالي"];
  return `<div class="fi"><style>${themeCss(th)}.fi .big{font-size:22px;font-weight:800;color:${th.primary}}.fi .sig{display:flex;justify-content:space-between;gap:16px;margin-top:40px}.fi .sig div{flex:1;text-align:center;border-top:1px solid #94a3b8;padding-top:6px;font-weight:600}</style>
  <div class="top" style="${th.logo_side === "right" ? "flex-direction:row-reverse" : ""}">
    <div style="width:34%">${seller.name ? `<b style="font-size:14px">${esc(seller.name)}</b><br/>` : ""}${seller.vat ? `الرقم الضريبي: <span class="n">${esc(seller.vat)}</span><br/>` : ""}${seller.cr ? `السجل التجاري: <span class="n">${esc(seller.cr)}</span><br/>` : ""}${esc(nationalAddress(seller))}</div>
    <div class="ttl" style="width:32%"><b>${tAr}</b><span>${tEn}</span></div>
    <div style="width:34%;display:flex;justify-content:flex-start;direction:${th.logo_side === "right" ? "rtl" : "ltr"}">${logo ? `<img class="logo" src="${logo}"/>` : ""}</div>
  </div>
  <table class="meta" style="margin-top:12px">
    ${row("رقم السند", "Voucher No.", `<span class="n"><b>${esc(p.number)}</b></span>`)}
    ${row("التاريخ", "Date", `<span class="n">${esc(p.date)}</span>`)}
  </table>
  <div class="sec"><span>تفاصيل السند</span><span>Details</span></div>
  <table class="party">
    ${row(isIn ? "استلمنا من" : "صُرف إلى", isIn ? "Received from" : "Paid to", `<b>${esc(p.party_name || "—")}</b>`)}
    ${row("المبلغ", "Amount", `<span class="n big">${money(p.amount)}${RIYAL}</span>`)}
    ${row("المبلغ كتابةً", "In words", esc(amountWords(p.amount)))}
    ${row("طريقة الدفع", "Method", `${p.method === "cash" ? "نقداً" : "تحويل بنكي"}${p.bank_name ? ` — ${esc(p.bank_name)}` : ""}`)}
    ${p.invoice_number ? row("مقابل فاتورة", "Against invoice", `<span class="n">${esc(p.invoice_number)}</span>`) : ""}
    ${row("البيان", "Description", esc(p.notes || (isIn ? "دفعة مستلمة" : "دفعة مصروفة")))}
  </table>
  <div style="display:flex;justify-content:flex-end;margin-top:16px">${seller.stamp ? `<div style="text-align:center"><img class="stamp" style="max-height:${th.stamp_size}px;max-width:${Math.round(th.stamp_size * 1.4)}px" src="${seller.stamp}"/><div style="font-size:9px;color:#64748b">ختم الشركة · Company Stamp</div></div>` : ""}</div>
  <div class="sig">${sign.map((x) => `<div>${x}<br/><span style="font-weight:400;color:#94a3b8;font-size:10px">التوقيع</span></div>`).join("")}</div>
  ${th.footer_text ? `<div style="margin-top:16px;font-size:10px;color:#334155;white-space:pre-line;border-inline-start:3px solid ${th.primary};padding:4px 8px">${esc(th.footer_text)}</div>` : ""}
</div>`;
}

export async function voucherHtml(p, company) {
  const s = await finApi.settings();
  const c = company || {}, z = s.zatca || {};
  return buildVoucherHtml(p, {
    logo: s.logo, theme: s.invoice_theme,
    seller: { ...z, name: z.seller_name || c.name, vat: z.vat_number || c.vat_number, cr: z.cr_number || c.cr_number,
      address: z.address || c.address, city: z.city || c.city, stamp: c.stamp || "" },
  });
}

export const printVoucher = async (p, company) => printInvoice(await voucherHtml(p, company), p.number);
export const pdfVoucher = async (p, company) => (await invoicePdf(await voucherHtml(p, company))).save(`${p.number}.pdf`);

// Mobile: native share sheet with the PDF. Fallback: download PDF + open WhatsApp chat with the party.
export async function shareVoucherWhatsApp(p, company) {
  const list = await (p.party_type === "supplier" ? finApi.suppliers() : finApi.customers()).catch(() => []);
  const party = (Array.isArray(list) ? list : list.items || []).find((x) => x.id === p.party_id);
  const pdf = await invoicePdf(await voucherHtml(p, company));
  const file = new File([pdf.output("blob")], `${p.number}.pdf`, { type: "application/pdf" });
  const kind = p.direction === "in" ? "سند قبض" : "سند صرف";
  const text = `${kind} ${p.number} من ${company?.name || ""}\nالتاريخ: ${p.date}\nالمبلغ: ${money(p.amount)} ر.س\n${amountWords(p.amount)}`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title: p.number, text }); return "shared"; }
    catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  pdf.save(`${p.number}.pdf`);
  window.open(`https://wa.me/${waPhone(party?.phone)}?text=${encodeURIComponent(`${text}\n(مرفق ملف PDF للسند)`)}`, "_blank");
  return party?.phone ? "fallback" : "fallback_nophone";
}

const ST = { draft: "مسودة", posted: "مُرحّل", reversed: "معكوس" };
export function buildJournalHtml(e, { seller = {}, logo, theme }) {
  const th = { ...DEFAULT_THEME, ...(theme || {}) };
  const lines = (e.lines || []).map((l) => `<tr><td class="n">${esc(l.account_code || "")}</td><td>${esc(l.account_name || "")}${l.description ? `<br/><span style="color:#64748b;font-size:10px">${esc(l.description)}</span>` : ""}</td><td class="n">${l.debit ? money(l.debit) : ""}</td><td class="n">${l.credit ? money(l.credit) : ""}</td></tr>`).join("");
  return `<div class="fi"><style>${themeCss(th)}.fi table.jl{width:100%;border-collapse:collapse;margin-top:8px}.fi table.jl th,.fi table.jl td{border:1px solid #cbd5e1;padding:6px 8px;font-size:12px;text-align:right}.fi table.jl th{background:${th.primary};color:#fff}.fi table.jl tfoot td{font-weight:800;background:#f1f5f9}.fi .sig{display:flex;justify-content:space-between;gap:16px;margin-top:40px}.fi .sig div{flex:1;text-align:center;border-top:1px solid #94a3b8;padding-top:6px;font-weight:600}</style>
  <div class="top" style="${th.logo_side === "right" ? "flex-direction:row-reverse" : ""}">
    <div style="width:34%">${seller.name ? `<b style="font-size:14px">${esc(seller.name)}</b><br/>` : ""}${seller.vat ? `الرقم الضريبي: <span class="n">${esc(seller.vat)}</span><br/>` : ""}${seller.cr ? `السجل التجاري: <span class="n">${esc(seller.cr)}</span><br/>` : ""}${esc(nationalAddress(seller))}</div>
    <div class="ttl" style="width:32%"><b>سند قيد</b><span>Journal Voucher</span></div>
    <div style="width:34%;display:flex;justify-content:flex-start;direction:${th.logo_side === "right" ? "rtl" : "ltr"}">${logo ? `<img class="logo" src="${logo}"/>` : ""}</div>
  </div>
  <table class="meta" style="margin-top:12px">
    ${row("رقم القيد", "Entry No.", `<span class="n"><b>${esc(e.number)}</b></span>`)}
    ${row("التاريخ", "Date", `<span class="n">${esc(e.date)}</span>`)}
    ${row("المرجع", "Reference", esc(e.reference || "—"))}
    ${row("البيان", "Description", esc(e.description || "—"))}
    ${row("الحالة", "Status", ST[e.status] || e.status)}
  </table>
  <table class="jl"><thead><tr><th style="width:14%">رقم الحساب</th><th>اسم الحساب</th><th style="width:18%">مدين</th><th style="width:18%">دائن</th></tr></thead>
    <tbody>${lines}</tbody>
    <tfoot><tr><td colspan="2">الإجمالي</td><td class="n">${money(e.total_debit)}${RIYAL}</td><td class="n">${money(e.total_credit)}${RIYAL}</td></tr></tfoot></table>
  <div style="margin-top:8px;font-size:11px">المبلغ كتابةً: <b>${esc(amountWords(e.total_debit))}</b></div>
  <div style="display:flex;justify-content:flex-end;margin-top:16px">${seller.stamp ? `<img class="stamp" style="max-height:${th.stamp_size}px;max-width:${Math.round(th.stamp_size * 1.4)}px" src="${seller.stamp}"/>` : ""}</div>
  <div class="sig">${["المحاسب", "المراجع", "المدير المالي"].map((x) => `<div>${x}<br/><span style="font-weight:400;color:#94a3b8;font-size:10px">التوقيع</span></div>`).join("")}</div>
  <div style="margin-top:10px;font-size:9px;color:#94a3b8">أُنشئ بواسطة: ${esc(e.created_by_name || "")}</div>
</div>`;
}
async function journalHtml(e, company) {
  const s = await finApi.settings();
  const c = company || {}, z = s.zatca || {};
  return buildJournalHtml(e, { logo: s.logo, theme: s.invoice_theme,
    seller: { ...z, name: z.seller_name || c.name, vat: z.vat_number || c.vat_number, cr: z.cr_number || c.cr_number, address: z.address || c.address, city: z.city || c.city, stamp: c.stamp || "" } });
}
export const printJournal = async (e, company) => printInvoice(await journalHtml(e, company), e.number);
export const pdfJournal = async (e, company) => (await invoicePdf(await journalHtml(e, company))).save(`${e.number}.pdf`);
